<template>
  <div class="box" :class="position_class">
    <span>{{text}}</span>
    <ion-icon v-if="show_brain" src="/assets/icon/brain.svg" class="icon"></ion-icon>
  </div>
</template>

<script>
import {IonIcon} from "@ionic/vue";

export default {
  name: "LoginBottomTips",
  components: {
    IonIcon
  },
  props: {
    text: {type: String},
    position: {type: String},
    show_brain: {type: String, default: ""}
  },
  data() {
    return {
      position_class: '',
    }
  },
  mounted() {
    if (this.position === 'right') {
      this.position_class = 'right'
    }
  }
}
</script>

<style scoped>
  .box{
    /*display: inline-block;*/
    /*margin: 0 auto;*/
    position: relative;
    text-align: center;
    margin-top: 2vh;
    color:  #61005f;
    font-size: var(--ecs-font-md);
  }
  .right{
    margin-right: -46vh;
  }
  .icon{
    position: absolute;
    top: 0.5vh;
  }
</style>
